import React, { useContext } from 'react';
import dropDownIcon from './assets/dropdown-icon.svg';
import { DropDownContext } from './custom-dropdown';

const DropdownHeader = () => {
  const { header, showDropdownIcon, isOpen } = useContext(DropDownContext);
  const { icon, title, color = undefined } = header;
  return (
    <div className={`header ${showDropdownIcon ? 'header-with-dropdown-icon' : ''}`}>
      <div>
        {icon && <img className="header-icon" src={icon} alt="icon" />}
        <span className="header-title" style={{ color }}>
          {title}
        </span>
      </div>
      {showDropdownIcon && (
        <img src={dropDownIcon} alt="dropdown" className={isOpen ? 'rotate' : ''} />
      )}
    </div>
  );
};

export default DropdownHeader;
